import { render, staticRenderFns } from "./placard_refill.vue?vue&type=template&id=b47d2bac&scoped=true"
import script from "./placard_refill.vue?vue&type=script&lang=js"
export * from "./placard_refill.vue?vue&type=script&lang=js"
import style0 from "./placard_refill.vue?vue&type=style&index=0&id=b47d2bac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b47d2bac",
  null
  
)

export default component.exports